(function () {
  class BundleContentsElement extends HTMLElement {
    connectedCallback() {
      this.switcher = document.querySelector('[data-active-bundle-key]');
      this.items = this.querySelectorAll('.bundle-item[data-bundle-key]');

      // Parse color trigger names from Liquid settings
      var colorTriggersAttr = this.getAttribute('data-color-triggers') || 'Color';
      this._colorTriggers = colorTriggersAttr.split(',').map(function (s) {
        return s.trim().toLowerCase();
      });

      // Parse main variant price map (variantId -> [price, compare_at_price])
      var pricesAttr = this.getAttribute('data-main-variant-prices');
      this._mainVariantPrices = {};
      if (pricesAttr) {
        try { this._mainVariantPrices = JSON.parse(pricesAttr); } catch (e) {}
      }

      // Money format from shop settings
      this._moneyFormat = this.getAttribute('data-money-format') || '${{amount}}';

      // Central state object
      this.bundleState = {
        bundleKey: this.getActiveBundleKey(),
        masterColor: '',
        items: {}
      };

      this.applyVisibility();
      this.initItemStates();
      this.initChangeColorToggles();
      this.initSwatchPickers();

      // Defer sibling-element-dependent init so that during Theme Editor
      // section reloads the variant picker and product form are connected first.
      var self = this;
      this._initRAF = requestAnimationFrame(function () {
        self._initRAF = null;
        if (!self.isConnected) return;

        // Master color sync
        self.readMasterColor();
        self.syncMasterColor(false);
        self.initMasterColorObserver();

        // Bundle Add to Cart
        self.initBundleAddToCart();

        // Initial pricing calculation
        self.updatePricing();
      });
    }

    getActiveBundleKey() {
      if (!this.switcher) return '';
      return this.switcher.getAttribute('data-active-bundle-key') || '';
    }

    isBundleMode() {
      return this.bundleState.bundleKey !== '' || !this.switcher;
    }

    applyVisibility() {
      var activeKey = this.getActiveBundleKey();

      // Standalone mode — no switcher, show all items
      if (!activeKey && !this.switcher) {
        var hasAny = false;
        this.items.forEach(function (item) {
          item.removeAttribute('hidden');
          hasAny = true;
        });
        if (hasAny) {
          this.removeAttribute('hidden');
        } else {
          this.setAttribute('hidden', '');
        }
        return;
      }

      if (!activeKey) {
        this.setAttribute('hidden', '');
        return;
      }

      var hasVisibleItems = false;

      this.items.forEach(function (item) {
        var itemKey = item.getAttribute('data-bundle-key') || '';
        if (itemKey === activeKey) {
          item.removeAttribute('hidden');
          hasVisibleItems = true;
        } else {
          item.setAttribute('hidden', '');
        }
      });

      if (hasVisibleItems) {
        this.removeAttribute('hidden');
      } else {
        this.setAttribute('hidden', '');
      }
    }

    initItemStates() {
      var self = this;
      var activeKey = this.bundleState.bundleKey;

      this.items.forEach(function (item) {
        if (self.switcher) {
          var itemKey = item.getAttribute('data-bundle-key') || '';
          if (itemKey !== activeKey) return;
        }

        var handle = item.getAttribute('data-product-handle');
        if (!handle) return;

        var activeSwatch = item.querySelector('.bundle-item__swatch--active');
        var color = activeSwatch ? (activeSwatch.getAttribute('data-value') || '') : '';

        self.bundleState.items[handle] = {
          variantId: item.getAttribute('data-variant-id') || '',
          color: color,
          available: true,
          manuallyChanged: false
        };
      });
    }

    initChangeColorToggles() {
      this.querySelectorAll('.bundle-item__change-color').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.bundle-item');
          var picker = item.querySelector('.bundle-item__color-picker');
          if (!picker) return;

          var isOpen = !picker.hidden;
          if (isOpen) {
            picker.hidden = true;
            btn.setAttribute('aria-expanded', 'false');
          } else {
            picker.hidden = false;
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    }

    initSwatchPickers() {
      var self = this;
      this.querySelectorAll('.bundle-item__swatch').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          if (swatch.disabled) return;

          var item = swatch.closest('.bundle-item');
          self.selectSwatch(item, swatch);

          // Mark as manually overridden
          var handle = item.getAttribute('data-product-handle');
          if (handle && self.bundleState.items[handle]) {
            self.bundleState.items[handle].manuallyChanged = true;
          }

          // Hide warning
          self.hideWarning(item);

          // Close picker
          var picker = item.querySelector('.bundle-item__color-picker');
          var btn = item.querySelector('.bundle-item__change-color');
          if (picker) picker.hidden = true;
          if (btn) btn.setAttribute('aria-expanded', 'false');

          // Recalculate pricing after color change
          self.updatePricing();
        });
      });
    }

    /* ── Master color reading ── */

    readMasterColor() {
      var variantPicker = document.querySelector('.block-product__variant-picker');
      if (!variantPicker) return;

      var variantInput = variantPicker.querySelector('variant-input');
      if (!variantInput) return;

      var optionNamesStr = variantInput.getAttribute('data-option-names');
      if (!optionNamesStr) return;

      var optionNames;
      try { optionNames = JSON.parse(optionNamesStr); } catch (e) { return; }

      // Find which option position is the color option
      var colorPos = -1;
      for (var i = 0; i < optionNames.length; i++) {
        if (this._colorTriggers.indexOf(optionNames[i].toLowerCase().trim()) !== -1) {
          colorPos = i;
          break;
        }
      }
      if (colorPos === -1) return;

      // Read the selected value from the fieldset at that position
      var fieldsets = variantInput.querySelectorAll('fieldset');
      var colorFieldset = fieldsets[colorPos];
      if (!colorFieldset) return;

      var valueSpan = colorFieldset.querySelector('.option_value');
      if (valueSpan) {
        this.bundleState.masterColor = valueSpan.textContent.trim();
      }
    }

    /* ── Observer for variant picker re-renders ── */

    initMasterColorObserver() {
      var self = this;

      var variantPicker = document.querySelector('.block-product__variant-picker');
      if (!variantPicker) return;

      this._variantObserver = new MutationObserver(function () {
        // Debounce: one sync per animation frame
        if (self._syncDebounce) return;
        self._syncDebounce = requestAnimationFrame(function () {
          self._syncDebounce = null;
          var oldColor = self.bundleState.masterColor;
          self.readMasterColor();
          if (self.bundleState.masterColor && self.bundleState.masterColor !== oldColor) {
            self.syncMasterColor(true);
          }
          // Recalculate pricing (main variant may have changed)
          self.updatePricing();
        });
      });

      this._variantObserver.observe(variantPicker, {
        childList: true,
        subtree: true
      });
    }

    /* ── Sync master color to bundle items ── */

    syncMasterColor(resetManualOverrides) {
      var masterColor = this.bundleState.masterColor;
      if (!masterColor) return;

      var self = this;
      var activeKey = this.bundleState.bundleKey;

      this.items.forEach(function (item) {
        if (self.switcher) {
          var itemKey = item.getAttribute('data-bundle-key') || '';
          if (itemKey !== activeKey) return;
        }

        var handle = item.getAttribute('data-product-handle');
        if (!handle) return;

        var itemState = self.bundleState.items[handle];
        if (!itemState) return;

        // A new master color resets all manual overrides
        if (resetManualOverrides) {
          itemState.manuallyChanged = false;
        }

        // Skip items the customer manually overrode
        if (itemState.manuallyChanged) return;

        // Find matching swatch by color name (case-insensitive)
        var swatches = item.querySelectorAll('.bundle-item__swatch');
        if (swatches.length === 0) return;

        var matchingSwatch = null;
        var masterLower = masterColor.toLowerCase().trim();

        swatches.forEach(function (swatch) {
          var val = (swatch.getAttribute('data-value') || '').toLowerCase().trim();
          if (val === masterLower) {
            matchingSwatch = swatch;
          }
        });

        if (!matchingSwatch) return;

        if (matchingSwatch.disabled) {
          // Color exists but is unavailable — show warning, keep current variant
          itemState.available = false;
          self.showWarning(item, masterColor);
        } else {
          // Color available — select it
          itemState.available = true;
          self.selectSwatch(item, matchingSwatch);
          self.hideWarning(item);
        }
      });
    }

    /* ── Swatch selection (shared by sync + manual click) ── */

    selectSwatch(item, swatch) {
      var swatchList = item.querySelector('.bundle-item__swatches');
      if (swatchList) {
        swatchList.querySelectorAll('.bundle-item__swatch').forEach(function (s) {
          s.classList.remove('bundle-item__swatch--active');
        });
      }
      swatch.classList.add('bundle-item__swatch--active');

      var variantId = swatch.getAttribute('data-variant-id');
      if (variantId) {
        item.setAttribute('data-variant-id', variantId);
      }

      var newImageUrl = swatch.getAttribute('data-variant-image');
      var img = item.querySelector('.bundle-item__image img');
      if (newImageUrl && img) {
        img.src = newImageUrl;
      }

      // Update price data attributes from swatch
      var swatchPrice = swatch.getAttribute('data-variant-price');
      var swatchCompare = swatch.getAttribute('data-variant-compare-price');
      if (swatchPrice) item.setAttribute('data-item-price', swatchPrice);
      if (swatchCompare) item.setAttribute('data-item-compare-price', swatchCompare);

      // Update color indicator (dot + name)
      var colorDot = item.querySelector('.bundle-item__color-dot');
      var colorName = item.querySelector('.bundle-item__color-name');
      var swatchColor = swatch.getAttribute('data-swatch-color');
      if (colorDot && swatchColor) colorDot.style.background = swatchColor;
      if (colorName) colorName.textContent = swatch.getAttribute('data-value') || '';

      var handle = item.getAttribute('data-product-handle');
      if (handle && this.bundleState.items[handle]) {
        this.bundleState.items[handle].color = swatch.getAttribute('data-value') || '';
        this.bundleState.items[handle].variantId = variantId || '';
      }
    }

    /* ── Money formatting ── */

    formatMoney(cents, format) {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      cents = parseInt(cents, 10) || 0;
      var dollars = (cents / 100).toFixed(2);
      var dollarsNoDecimals = Math.round(cents / 100).toString();
      var dollarsWithComma = dollars.replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
      var dollarsNoDecimalsWithComma = dollarsNoDecimals.replace(/(\d)(?=(\d{3})+$)/g, '$1,');

      return format
        .replace('{{amount_with_comma_separator}}', dollarsWithComma.replace('.', ','))
        .replace('{{amount_no_decimals_with_comma_separator}}', dollarsNoDecimalsWithComma.replace(',', '.'))
        .replace('{{amount_with_apostrophe_separator}}', dollarsWithComma.replace('.', "'"))
        .replace('{{amount_no_decimals}}', dollarsNoDecimals)
        .replace('{{amount}}', dollars);
    }

    /* ── Read current main product variant price ── */

    readMainVariantPrice() {
      // Find the product form's selected variant ID
      var section = this.closest('.shopify-section') || this.closest('section');
      if (!section) return { price: 0, compareAtPrice: 0 };

      var form = section.querySelector('product-form form[data-type="add-to-cart-form"]');
      if (!form) return { price: 0, compareAtPrice: 0 };

      var idInput = form.querySelector('input[name="id"]');
      if (!idInput) return { price: 0, compareAtPrice: 0 };

      var variantId = idInput.value;
      var entry = this._mainVariantPrices['"' + variantId + '"'] || this._mainVariantPrices[variantId];
      if (entry && Array.isArray(entry)) {
        return {
          price: entry[0] || 0,
          compareAtPrice: entry[1] || 0
        };
      }

      return { price: 0, compareAtPrice: 0 };
    }

    /* ── Update all pricing UI ── */

    updatePricing() {
      if (!this.isBundleMode()) return;

      var activeKey = this.bundleState.bundleKey;
      var hasSwitcher = !!this.switcher;
      var totalPrice = 0;
      var totalCompareAtPrice = 0;
      var visibleCount = 0;

      // Sum child item prices
      this.items.forEach(function (item) {
        if (item.hidden) return;
        if (hasSwitcher) {
          var itemKey = item.getAttribute('data-bundle-key') || '';
          if (itemKey !== activeKey) return;
        }

        visibleCount++;
        totalCompareAtPrice += parseInt(item.getAttribute('data-item-compare-price') || '0', 10);
        totalPrice += parseInt(item.getAttribute('data-item-price') || '0', 10);
      });

      // Add main product price
      var mainPrice = this.readMainVariantPrice();
      totalPrice += mainPrice.price;
      totalCompareAtPrice += (mainPrice.compareAtPrice > 0 ? mainPrice.compareAtPrice : mainPrice.price);

      // Count = visible bundle items only (main product is the bundle itself)
      var totalCount = visibleCount;

      var savings = totalCompareAtPrice - totalPrice;
      if (savings < 0) savings = 0;
      var hasSavings = savings > 0 && totalCompareAtPrice > totalPrice;

      var fmt = this._moneyFormat;
      var self = this;

      // Item count pill
      var itemCountEl = this.querySelector('.bundle-contents__item-count');
      var itemCountPill = this.querySelector('.bundle-contents__item-count-pill');

      if (itemCountEl) itemCountEl.textContent = totalCount;
      if (itemCountPill && totalCount > 0) itemCountPill.hidden = false;

      // Legacy subtitle elements (may not exist)
      var subtitleEl = this.querySelector('.bundle-contents__subtitle');
      var subtitleValueEl = this.querySelector('.bundle-contents__subtitle-value');
      var totalValueLabelEl = this.querySelector('.bundle-contents__total-value-label');

      if (subtitleEl && totalCount > 0) subtitleEl.hidden = false;
      if (subtitleValueEl && totalCompareAtPrice > 0) {
        subtitleValueEl.hidden = false;
      } else if (subtitleValueEl) {
        subtitleValueEl.hidden = true;
      }
      if (totalValueLabelEl) {
        totalValueLabelEl.textContent = this.formatMoney(totalCompareAtPrice, fmt);
      }

      // Savings pill
      var savingsPill = this.querySelector('.bundle-contents__savings-pill');
      var savingsAmountEl = this.querySelector('.bundle-contents__savings-amount');
      if (savingsPill) savingsPill.hidden = !hasSavings;
      if (savingsAmountEl && hasSavings) {
        savingsAmountEl.textContent = this.formatMoney(savings, fmt);
      }

      // Summary row — skip if manual overrides are set in theme editor
      if (!this.hasAttribute('data-manual-summary')) {
        var summaryEl = this.querySelector('.bundle-contents__summary');
        var summaryCompareEl = this.querySelector('.bundle-contents__summary-compare');
        var summaryCompareAmountEl = this.querySelector('.bundle-contents__summary-compare-amount');
        var summaryPriceEl = this.querySelector('.bundle-contents__summary-price');
        var summarySavingsEl = this.querySelector('.bundle-contents__summary-savings');
        var summaryRight = this.querySelector('.bundle-contents__summary-right');

        var mainPrice = this.readMainVariantPrice();
        var displayPrice = mainPrice.price;
        var displayCompare = mainPrice.compareAtPrice;
        var displaySavings = (displayCompare > 0 && displayCompare > displayPrice) ? displayCompare - displayPrice : 0;
        var displayHasSavings = displaySavings > 0;

        if (summaryEl && totalCount > 0) summaryEl.hidden = false;
        if (summaryPriceEl) summaryPriceEl.textContent = this.formatMoney(displayPrice, fmt);

        if (summaryCompareEl) {
          if (displayHasSavings) {
            if (summaryCompareAmountEl) {
              summaryCompareAmountEl.textContent = this.formatMoney(displayCompare, fmt);
            }
            summaryCompareEl.hidden = false;
          } else {
            summaryCompareEl.hidden = true;
          }
        }

        if (summaryRight) summaryRight.hidden = !displayHasSavings;
        if (summarySavingsEl && displayHasSavings) {
          summarySavingsEl.textContent = this.formatMoney(displaySavings, fmt);
        }
      }

    }

    /* ── Warning messages ── */

    showWarning(item, colorName) {
      var warning = item.querySelector('.bundle-item__warning');
      if (!warning) return;

      var colorSpan = warning.querySelector('.bundle-item__warning-color');
      if (colorSpan) colorSpan.textContent = colorName;

      warning.hidden = false;

      // Bind the "choose another color" link once
      var chooseLink = warning.querySelector('.bundle-item__warning-choose');
      if (chooseLink && !chooseLink.dataset.bound) {
        chooseLink.dataset.bound = 'true';
        chooseLink.addEventListener('click', function (e) {
          e.preventDefault();
          var picker = item.querySelector('.bundle-item__color-picker');
          var btn = item.querySelector('.bundle-item__change-color');
          if (picker) {
            picker.hidden = false;
            if (btn) btn.setAttribute('aria-expanded', 'true');
          }
        });
      }
    }

    hideWarning(item) {
      var warning = item.querySelector('.bundle-item__warning');
      if (warning) warning.hidden = true;
    }

    /* ── Bundle Add to Cart ── */

    initBundleAddToCart() {
      var self = this;
      var section = this.closest('.shopify-section') || this.closest('section');
      if (!section) return;

      // Use event delegation on the section rather than binding directly to each
      // form.  The variant swatch code replaces .sticky-sticky__buy-buttons via
      // innerHTML when the variant changes, which destroys any listeners that
      // were attached to the old sticky form element.  A section-level capture
      // listener survives those DOM replacements.
      section.addEventListener('submit', function (event) {
        var form = event.target;
        if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
        var productFormEl = form.closest('product-form');
        if (!productFormEl) return;

        if (!self.isBundleMode()) return;
        if (self.getVisibleBundleItems().length === 0) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        self.handleBundleSubmit(productFormEl, form);
      }, true);
    }

    getVisibleBundleItems() {
      var activeKey = this.bundleState.bundleKey;
      var hasSwitcher = !!this.switcher;
      var visible = [];
      this.items.forEach(function (item) {
        if (item.hidden) return;
        if (hasSwitcher && (item.getAttribute('data-bundle-key') || '') !== activeKey) return;
        visible.push(item);
      });
      return visible;
    }

    validateBundleItems() {
      var items = [];
      var visibleItems = this.getVisibleBundleItems();

      if (visibleItems.length === 0) {
        return { valid: false, error: 'No bundle items configured.' };
      }

      for (var i = 0; i < visibleItems.length; i++) {
        var item = visibleItems[i];
        var variantId = item.getAttribute('data-variant-id');

        if (!variantId) {
          var titleEl = item.querySelector('.bundle-item__title');
          var name = titleEl ? titleEl.textContent.trim() : 'A bundle item';
          return { valid: false, error: '"' + name + '" has no variant selected.' };
        }

        // Check if this item has all swatches disabled (entirely unavailable)
        var swatches = item.querySelectorAll('.bundle-item__swatch');
        if (swatches.length > 0) {
          var hasAvailable = false;
          swatches.forEach(function (s) {
            if (!s.disabled) hasAvailable = true;
          });
          if (!hasAvailable) {
            var titleEl2 = item.querySelector('.bundle-item__title');
            var name2 = titleEl2 ? titleEl2.textContent.trim() : 'A bundle item';
            return { valid: false, error: '"' + name2 + '" is currently sold out.' };
          }
        }

        items.push({ id: variantId, quantity: 1 });
      }

      return { valid: true, items: items };
    }

    handleBundleSubmit(productFormEl, form) {
      var submitButton = productFormEl.querySelector('[type="submit"]');
      if (!submitButton) return;
      if (submitButton.getAttribute('aria-disabled') === 'true') return;

      // Read form quantity
      var qtyInput = form.querySelector('input[name="quantity"]');
      var quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

      // Validate all bundle items (only component products, not the parent)
      var validation = this.validateBundleItems();
      if (!validation.valid) {
        this.showFormError(productFormEl, validation.error);
        return;
      }

      // Apply quantity to every line
      var items = validation.items.map(function (item) {
        return { id: item.id, quantity: quantity };
      });

      // Loading state
      this.clearFormError(productFormEl);
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');

      var self = this;
      var cart = document.querySelector('cart-drawer') || document.querySelector('main-cart');
      var hasError = false;

      // Filter out benefit items already in cart to prevent duplicates
      var filterPromise = (window.CartBenefits && typeof window.CartBenefits.filterBenefitsFromItems === 'function')
        ? window.CartBenefits.filterBenefitsFromItems(items)
        : Promise.resolve(items);

      filterPromise.then(function (filteredItems) {
        if (filteredItems.length === 0) {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          return;
        }

      // Build FormData — same indexed pattern as section-product-bundle.js
      var formData = new FormData();
      filteredItems.forEach(function (item, index) {
        formData.append('items[' + index + '][id]', item.id);
        formData.append('items[' + index + '][quantity]', item.quantity);
      });

      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cart.getSectionsToRender().map(function (s) { return s.id; })
        );
        formData.append('sections_url', window.location.pathname);
      }

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
        .then(function (res) { return res.json(); })
        .then(function (response) {
          if (response.status) {
            hasError = true;
            var msg = response.description || response.message || 'Could not add bundle to cart.';
            self.showFormError(productFormEl, msg);
            return;
          }

          // Success
          var isCartPage = document.body.classList.contains('template-cart');
          if (isCartPage) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }

          // Desktop "redirect to cart page" setting
          var desktopAction = cart.getAttribute('data-action-add-cart-desktop');
          if (desktopAction === 'page' && window.innerWidth > 767) {
            window.location = window.routes.cart_url;
            return;
          }

          // Render cart drawer contents and open it
          cart.renderContents(response);
          self.openCartDrawer(cart);
        })
        .catch(function (e) {
          console.error('Bundle add to cart error:', e);
          hasError = true;
          var errorMsg = (window.cartStrings && window.cartStrings.error)
            || 'There was an error while updating your cart. Please try again.';
          self.showFormError(productFormEl, errorMsg);
        })
        .finally(function () {
          submitButton.classList.remove('loading');
          var label = submitButton.querySelector('.hidden-on-load');
          if (label) label.classList.remove('opacity-0');
          if (!hasError) submitButton.removeAttribute('aria-disabled');

          document.dispatchEvent(
            new CustomEvent('nextsky:cart:added', { detail: { success: !hasError } })
          );
        });
      }); // end filterPromise.then
    }

    openCartDrawer(cart) {
      // Replicate the essential eventModal("open") behavior for cart-drawer
      document.documentElement.classList.add('open-modal');
      cart.classList.remove('content-hidden');
      cart.classList.add('active', 'remove');
      document.dispatchEvent(new CustomEvent('modal:opened'));
    }

    showFormError(productFormEl, message) {
      var wrapper = productFormEl.querySelector('.product-form__error-message-wrapper');
      if (wrapper) {
        var span = wrapper.querySelector('.product-form__error-message');
        if (span) span.textContent = message;
        wrapper.hidden = false;
      }
    }

    clearFormError(productFormEl) {
      var wrapper = productFormEl.querySelector('.product-form__error-message-wrapper');
      if (wrapper) wrapper.hidden = true;
    }

    /* ── Cleanup ── */

    disconnectedCallback() {
      if (this._initRAF) {
        cancelAnimationFrame(this._initRAF);
      }
      if (this._variantObserver) {
        this._variantObserver.disconnect();
      }
      if (this._syncDebounce) {
        cancelAnimationFrame(this._syncDebounce);
      }
    }
  }

  if (!customElements.get('bundle-contents')) {
    customElements.define('bundle-contents', BundleContentsElement);
  }
})();
